import { createTracker as createPublicTracker } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { getParsedReauthCookieValue } from '../utils/cookies';
const anonymousTracker = withSessionReplay(createPublicTracker({
  standalone: true,
  properties: {
    deviceId: makeUuid()
  }
}));
export const loginVerificationWithHSAuthInitiated = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator', {
    action: 'Initiated',
    type: 'login-verification-hs-authenticator-initiated'
  });
};
export const loginVerificationWithHSAuthAccomplished = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator', {
    action: 'Accomplished',
    type: 'login-verification-hs-authenticator-succeded'
  });
};
export const loginVerificationWithHSAuthFailed = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator', {
    action: 'Failed',
    type: 'login-verification-hs-authenticator-failed'
  });
};
export const loginVerificationWithHSAuthResend = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator Resent After Error', {
    action: 'Resend',
    type: 'login-verification-hs-authenticator-resent'
  });
};
export const loginVerificationWithHSAuthCodeInitiated = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator Code', {
    action: 'Initiated',
    type: 'login-verification-hs-authenticator-code-initiated'
  });
};
export const loginVerificationWithHSAuthCodeAccomplished = () => {
  anonymousTracker.track('Loginui', 'Login Verification With Hubspot Authenticator Code', {
    action: 'Accomplished',
    type: 'login-verification-hs-authenticator-code-succeded'
  });
};
export const trackRememberThisDevice = () => {
  anonymousTracker.track('Loginui', 'Remember This Device', {
    action: 'Initiated',
    type: 'login-and-remeber-device'
  });
};
export const trackDoNotRememberThisDevice = () => {
  anonymousTracker.track('Loginui', 'Do Not Remember This Device', {
    action: 'Initiated',
    type: 'login-and-do-not-remeber-device'
  });
};
export const trackSmartLoginLoad = screen => {
  const {
    clientType,
    clientVersion,
    loginAttemptId
  } = getParsedReauthCookieValue() || {};
  anonymousTracker.track('Loginui', 'Smart Login Page Opened', {
    screen,
    appIdentifier: clientType,
    appVersion: clientVersion,
    attemptId: loginAttemptId
  });
};
export const trackTwoFactorRecoveryMobileAuth = reason => {
  anonymousTracker.track('Loginui', 'Recovery For Mobile Auth', {
    action: 'Initiated',
    type: `hs-authenticator-recovery-${reason}`
  });
};
export const trackLoginPageView = () => {
  anonymousTracker.track('Loginui', 'Page View For Login');
};
export const trackSignupLinkClick = screen => {
  anonymousTracker.track('Loginui', 'Signup Link Click', {
    screen
  });
};
export const trackVettingPageView = () => {
  anonymousTracker.track('Loginui', 'Page View For Vetting');
};
export const trackSmartLoginPasswordLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Password Login Click', {
    screen
  });
};
export const trackSmartLoginPasskeyLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Passkey Login Click', {
    screen
  });
};
export const trackSmartLoginGoogleLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Google Login Click', {
    screen
  });
};
export const trackSmartLoginAppleLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Apple Login Click', {
    screen
  });
};
export const trackSmartLoginMicrosoftLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Microsoft Login Click', {
    screen
  });
};
export const trackSmartLoginSsoLogin = screen => {
  anonymousTracker.track('Loginui', 'Smart Login Sso Login Click', {
    screen
  });
};
export const trackForgotPasswordClick = screen => {
  anonymousTracker.track('Loginui', 'Forgot My Password Click', {
    screen
  });
};
export const trackPasswordResetClick = () => {
  anonymousTracker.track('Loginui', 'Reset Your Password Click');
};
export const trackNametagRecoveryClick = () => {
  anonymousTracker.track('Loginui', 'Recovery Clicked', {
    action: 'nametag',
    screen: 'control',
    subscreen: '2fa-recovery'
  });
};
export const trackSupportRecoveryClick = () => {
  anonymousTracker.track('Loginui', 'Recovery Clicked', {
    action: 'contact-support',
    screen: 'control',
    subscreen: '2fa-recovery'
  });
};